import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MessageSquare, Headphones } from 'lucide-react';

const Contact = () => {
    const { t, i18n } = useTranslation();
    const primaryGreen = "#006C35";
    const isAr = i18n.language === 'ar';

    const contactMethod = {
        title: t('contact.methodTitle'),
        email: "VendorSupp@ksu.edu.sa",
        description: t('contact.methodDesc')
    };

    return (
        <div className="min-h-screen bg-gray-50 pb-20 overflow-hidden">
            {/* Header Section */}
            <div className="bg-white border-b border-gray-100 pt-32 pb-16">
                <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8`}>
                    <h1 className={`text-4xl font-extrabold text-gray-900 ${isAr ? 'border-r-8 pr-6' : 'border-l-8 pl-6'} inline-block`} style={{ borderColor: primaryGreen }}>
                        {t('contact.title')}
                    </h1>
                </div>
            </div>

            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
                <div className={`bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100`}>

                    <div className={`flex items-center gap-4 mb-8`}>
                        <div className="p-3 rounded-2xl bg-green-50 text-[#006C35]">
                            <Headphones size={32} />
                        </div>
                        <div>
                            <h2 className={`text-2xl font-bold text-gray-800`}>{t('contact.subtitle')}</h2>
                        </div>
                    </div>

                    <div className="space-y-8">
                        <div className="p-6 rounded-2xl bg-gray-50 border border-gray-100 transition-all hover:shadow-md">
                            <h3 className="text-xl font-bold text-[#006C35] mb-4">{contactMethod.title}</h3>
                            {/* <p className="text-gray-600 mb-6 leading-relaxed">
                                {contactMethod.description}
                            </p> */}

                            <a
                                href={`mailto:${contactMethod.email}`}
                                className={`group flex items-center justify-between p-4 bg-white rounded-xl border border-gray-200 hover:border-[#006C35] transition-all`}
                            >
                                <div className={`flex items-center gap-3`}>
                                    <div className="p-2 rounded-lg bg-green-50 text-[#006C35] group-hover:bg-[#006C35] group-hover:text-white transition-all">
                                        <Mail size={20} />
                                    </div>
                                    <span className="font-semibold text-gray-700">{contactMethod.email}</span>
                                </div>
                                <span className="text-[#006C35] font-bold text-sm hidden sm:block">{t('contact.sendEmail')}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
